import { OrderItemType } from '@wix/cashier-express-checkout-widget/dist/src/types/OrderItem';
export const getAdditionalFeesOrderItems = fees => (fees == null ? void 0 : fees.map((fee, index) => {
  var _fee$price;
  return {
    id: fee.code ?? `additional-fee-${index}`,
    name: fee.name ?? /* istanbul ignore next */'',
    price: ((_fee$price = fee.price) == null ? void 0 : _fee$price.amount) ?? /* istanbul ignore next */'0',
    quantity: 1,
    type: OrderItemType.Fee
  };
})) || /* istanbul ignore next */[];
//# sourceMappingURL=getAdditionalFeesOrderItems.js.map